/**
 * Composer-specific control metrics. The glyph SIZE moved to
 * `ui/iconButtonMetrics` once the note editor's toolbar wanted the same number.
 *
 * A leaf module because `ChatComposer` imports the buttons, so the buttons
 * cannot import back from it.
 *
 * These existed as literals with comments pointing at each other — "Sized to
 * match the mic + send buttons", "matching AttachmentButton and the dictation
 * mic" — which is coupling by prose: it documents the intent and does nothing
 * to enforce it. Three of the four controls ended up at 24px and the fourth at
 * 16px anyway.
 */

/**
 * Marks a label that collapses when the composer gets narrow, leaving its
 * control icon-only. `ChatComposer` owns the container query that acts on it.
 *
 * A constant rather than three copies of the string: the selector and the
 * opt-ins live in different files, and a control that spells the class wrong
 * simply never collapses — silently, and only at widths nobody tests at. The
 * Add-context pill spent the 2026-09 pass not opting in at all, which is how
 * the 352px panel ended up with a two-row action row.
 *
 * A collapsing control MUST carry its name some other way — an `aria-label`
 * and a tooltip. The label is what sighted users read, so hiding it without a
 * replacement makes the control anonymous rather than compact.
 */
export const COMPOSER_LABEL_CLASS = 'composer-label';
